<template>
  <div id="viewVideo">
   <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器列表</el-breadcrumb-item>
        <el-breadcrumb-item>视频播放</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <el-row :gutter="240">
                 <!-- 视频播放区域 -->
                <el-col :span="16"  >
                    <el-row :gutter="20" >
                        <div id="video" class="image_tofile" >
                             <div id="video-container" ref="imageTofile" style="width:1100px;"></div>
                        </div>
                    </el-row >
                </el-col>
                <el-col :span="8"  >
                  <el-row :gutter="20" >
                          <el-col >
                             <el-button type="primary" @click="toRobot()" style="float:right;margin-left:0%">返回</el-button>
                          </el-col>
                    </el-row >
                    <el-row :gutter="20" >
                          <el-col >
                            <h2>录像视频查询</h2>
                          </el-col>
                    </el-row >
                    <el-row :gutter="20" >
                          <el-col >
                            <el-date-picker v-model="startTimeStr" value-format="yyyy-MM-dd HH:mm:ss"   type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"  />
                          </el-col>
                    </el-row >
                    <el-row :gutter="10" >
                       <el-col :span="12" >
                          <el-button type="primary" @click="initPlayer()" style="float:left;">直播</el-button>
                        </el-col>
                        <el-col :span="12" :push="0" >
                          <el-button type="primary" @click="broadcast()" style="float:right;">播放</el-button>
                        </el-col>
                    </el-row >
                </el-col>
        </el-row>
    </el-card >
  </div>
</template>
<script src="../js/jquery.min.js"></script>
<script>
import EZUIKit from "ezuikit-js";
export default {
  name: 'viewVideo',
  data(){
      return {
          startTimeStr:[],
          player:'',
          reconnectCount:'',
          htmlUrl: '',
          id:'',
          token:'',
          isView:false
      }
  },
  created(){
    
  },
  mounted(){
    this.initPlayer();
  },
  watch: {
    "startTimeStr"(newVal) {
      if (newVal == null) {
        this.startTimeStr = [];
      }
    },
  },
  methods:{
      //挑战倒机器列表页
      toRobot(){
         this.$router.push('/robot') 
      },
      broadcast(){
        if(this.startTimeStr.length==0){
          return   this.$message.error("请输入开始和结束时间!");
        }
        this.clear();
        var query = this.$route.query
        this.token = this.$cookies.get("token")
        let startTimeStrone =this.startTimeStr[0].replace("-","").replace(":","").replace("-","").replace(":","").replace(" ","")
        console.log(startTimeStrone)
        let startTimeStrTwo=this.startTimeStr[1].replace("-","").replace(":","").replace("-","").replace(":","").replace(" ","")
        console.log(startTimeStrTwo)
        var urlZB= "ezopen://open.ys7.com/"+query.No+"/1.local.rec?"+"begin="+startTimeStrone+"&end="+startTimeStrTwo
        console.log(urlZB)
        this.player =  new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: "video-container",
        accessToken:this.token,
        url: urlZB,
        audio: 1,
        template: "voice", 
        width: 1200,
        height: 550
        });
        this.cleanMessage()
      },
      cleanMessage(){
        setTimeout(function(){
        var broadcasts = document.getElementsByClassName('broadcast');
        for (var i = 0; i < broadcasts.length; i++) {
          var broadcast=broadcasts[i];
          broadcast.style="display:none";
          }
          var fullScreen = document.getElementById('fullScreen');
          if(fullScreen!=undefined && fullScreen.style !=null){
            fullScreen.style="display:none";
          }
        },300);
      },
      //清理播放器
      clear(){
        if (this.player!=null){
          var video=document.getElementById("video")
          var videocontainer=document.getElementById("video-container")
          video.removeChild(videocontainer);
          var node = document.createElement('div');
          node.setAttribute("id","video-container");
          document.getElementById("video").appendChild(node)
        }
      },
      initPlayer(){
        this.clear();
        var query = this.$route.query
        this.token = window.sessionStorage.getItem("token")
        var urlZB= "ezopen://open.ys7.com/"+query.No+"/1.live"
        this.player =  new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: "video-container",
        accessToken:this.token,
        url: urlZB,
        audio: 1,
        template: "voice", 
        width: 1200,
        height: 550
        });
        this.cleanMessage()
      },
   }
}
</script>

<style lang="less" scoped>
.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}
.broadcast{
  display:none
}
</style>


// WEBPACK FOOTER //
// src/components/robot/ViewVideo.vue